import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import Select, { type SelectOption, type SelectProps } from '@rio-cloud/rio-uikit/Select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { type Control, useController } from 'react-hook-form';

import { ValidationViolation } from './ValidationViolation.tsx';

type Props = SelectProps<SelectOption> & {
    // biome-ignore lint/suspicious/noExplicitAny: <react-hook-form> types
    control: Control<any>;
    label: string;
    className?: string;
    name: string;
    formGroupClassName?: string;
    options: SelectOption[];
};

export const ControlledSelect = forwardRef<HTMLInputElement, Props>(
    ({ label, name, control, formGroupClassName, options, selectedOptionText, ...props }, _ref) => {
        const { field, fieldState } = useController({ control, name: name });
        return (
            <div
                className={classNames('form-group', formGroupClassName, {
                    'form-group-lg': false,
                    'has-error': fieldState.invalid,
                    'has-feedback': fieldState.invalid,
                })}
            >
                <FormLabel htmlFor={field.name}>{label}</FormLabel>
                <Select
                    {...props}
                    name={name}
                    id={field.name}
                    options={options}
                    value={field.value ? [field.value] : []}
                    selectedOptionText={selectedOptionText ?? options.find(option => option.id === field.value)?.label}
                    onChange={option => field.onChange(option ? option.id : '')}
                />
                <ValidationViolation violations={fieldState.error?.message} />
            </div>
        );
    }
);
